import { createFileRoute } from "@tanstack/react-router";
import React from "react";

export const Route = createFileRoute("/$lang/contact")({
  component: React.lazy(() =>
    import("@/pages/information/contact").then((mod) => ({
      default: mod.ContactPage,
    })),
  ),
});
